import React from 'react';
import { InputIsActiveStyle } from './style';

export default function InputIsActive({ isActive, setIsActive }) {
  return (
    <InputIsActiveStyle thisIs={isActive}>
      <p>Empresa ativa?</p>
      <button onClick={() => setIsActive(!isActive)}>{isActive ? 'Sim' : 'Não'}</button>
    </InputIsActiveStyle>
  );
}
